import React, { useState, useEffect } from 'react';

function LapMG() {
  const [LapPasangData, setLapPasangData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [listTransaksi, setListTransaksi] = useState([]);
  const [no_transaksi, setNoTransaksi] = useState('');
  const [filters, setFilters] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const schema = localStorage.getItem('schema');

  const numericKeys = [
    'JARAK',
    'T20_UANG_MAKAN',
    'T20_KULI',
    'T20_SUPIR',
    'T20_TAMBAH',
    'T20_TOL',
    'UANG_JALAN',
    'LITER',
    'TOTAL',
    'T20_BORONGAN',
    'T20_BRG_MANUAL',
    'TMBH_SOLAR1',
    'TMBH_SOLAR2',
    'ONTIME_TOTAL',
    'KERNET',
  ];

  const columns = [
    'WILAYAH_ASAL',
    'WILAYAH_TUJUAN',
    'SUBCITY',
    'JARAK',
    'T20_UANG_MAKAN',
    'T20_KULI',
    'T20_SUPIR',
    'T20_TAMBAH',
    'T20_TOL',
    'UANG_JALAN',
    'LITER',
    'TOTAL',
    'T20_BORONGAN',
    'T20_BRG_MANUAL',
    'TMBH_SOLAR1',
    'TMBH_SOLAR2',
    'ONTIME_TOTAL',
    'KERNET',
  ];

const columnLabels = {
  WILAYAH_ASAL: 'Asal',
  WILAYAH_TUJUAN: 'Tujuan',
  SUBCITY: 'Sub Kota',
  JARAK: 'Jarak (Km)',
  T20_UANG_MAKAN: 'Uang Makan',
  T20_KULI: 'Kuli',
  T20_SUPIR: 'Supir',
  T20_TAMBAH: 'Tambahan',
  T20_TOL: 'Tol',
  UANG_JALAN: 'Uang Jalan',
  LITER: 'Liter',
  TOTAL: 'Total',
  T20_BORONGAN: 'Brgn 20',
  T20_BRG_MANUAL: 'Brgn Manual',
  TMBH_SOLAR1: 'Tmbh Solar',
  TMBH_SOLAR2: 'Brgn + Tmbh Solar',
  ONTIME_TOTAL: 'Ontime',
  KERNET: 'Kernet',
};


  const formatNumber = (value) =>
    isNaN(value) ? value : new Intl.NumberFormat('id-ID').format(Number(value));

  const fetchPilihanTransaksi = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/lap_mg.php?caller=pilih_mg&schema=${schema}`);
      const data = await res.json();
      if (Array.isArray(data)) {
        setListTransaksi(data);
        if (data.length > 0) {
          setNoTransaksi(data[0].NO_TRANSAKSI);  
        }
      }
    } catch (error) {
      alert('Gagal memuat pilihan transaksi');
    }
  };

  const fetchLapPasangData = async () => {
    if (!no_transaksi) return;
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/lap_mg.php?caller=isi_mg&schema=${schema}&no_transaksi=${no_transaksi}`;
      const response = await fetch(url);
      const data = await response.json();
      if (Array.isArray(data)) {
        setLapPasangData(data);
        setFilteredData(data);
      } else {
        throw new Error('Data tidak valid');
      }
    } catch (error) {
      alert('Gagal memuat data');
    }
  };

  useEffect(() => {
    fetchPilihanTransaksi();
  }, []);

  useEffect(() => {
    fetchLapPasangData();
  }, [no_transaksi]);

  useEffect(() => {
    let filtered = LapPasangData.filter((item) =>
      Object.keys(filters).every((key) =>
        filters[key] === '' || String(item[key] ?? '').toLowerCase().includes(filters[key].toLowerCase())
      )
    );
    setFilteredData(filtered);
  }, [filters, LapPasangData]);

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction });

    const sorted = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredData(sorted);
  };

  const getSortIcon = (key) =>
    sortConfig.key === key ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '';

  return (
    <div style={{ padding: '20px', backgroundColor: '#fff' }}>
      <h2 style={{ color: '#9B459C' }}>Laporan Master Gaji</h2>
      <div style={{ marginBottom: '10px' }}>
        <label>Pilih: </label>
        <select
          value={no_transaksi}
          onChange={(e) => setNoTransaksi(e.target.value)}
          style={{ marginLeft: '10px', padding: '5px' }}
        >
          {listTransaksi.map((item, idx) => (
            <option key={idx} value={item.NO_TRANSAKSI}>
              {item.JNS_KENDARAAN} ( {item.TGL_TRANSAKSI} - {item.NO_TRANSAKSI} )
            </option>
          ))}
        </select>
        <button onClick={fetchLapPasangData} style={{ marginLeft: '10px', padding: '5px 10px' }}>
          Refresh
        </button>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th
                  key={col}
                  onClick={() => handleSort(col)}
                  style={{
                    border: '1px solid #ccc',
                    padding: '8px',
                    backgroundColor: '#f2f2f2',
                    textAlign: 'center',
                    cursor: 'pointer',
                  }}
                >
                   {columnLabels[col] || col} {getSortIcon(col)}
                </th>
              ))}
            </tr>
            <tr>
              {columns.map((col) => (
                <th key={`filter-${col}`} style={{ border: '1px solid #ccc', padding: '4px' }}>
                  <input
                    type="text"
                    placeholder="Filter..."
                    style={{
                      width: '90%',
                      padding: '4px',
                      borderRadius: '4px',
                      border: '1px solid #ddd',
                    }}
                    onChange={(e) => setFilters({ ...filters, [col]: e.target.value })}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, idx) => (
                <tr key={idx}>
                  {columns.map((key) => (
                    <td
                      key={key}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        textAlign: numericKeys.includes(key) ? 'right' : 'left',
                      }}
                    >
                      {numericKeys.includes(key) ? formatNumber(item[key]) : item[key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: 'center', padding: '10px' }}>
                  Tidak ada data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LapMG;
